import React, { useEffect, useState } from "react";

import axios from "axios";
import IreMonthWiseTable from "./TableView/IreMonthWiseTable";
import Monthly_Yealy_Comparison from "./TableView/Monthly_Yealy_Comparison";
import DateWiseJBB from "./TableView/DateWiseJBB";
import { getCurrentDate, getCurrentMonthFirstDate } from "../../../Utilitie";

const keys = ["JUMBO", "BTPN", "NBOX"];
const urlPrefix = process.env.REACT_APP_URL_PREFIX;
const TableMaster = ({
  date,
  setMonthWiseData,
  monthWiseData,
  summaryData,
  setSummaryData,
}) => {
  const [startDate, setStartDate] = useState(getCurrentMonthFirstDate());

  const [endDate, setEndDate] = useState(getCurrentDate());

  const [currentPage, setCurrentPage] = useState(1);
  const entriesPerPage = 31;

  const [rawdata, setRawdata] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(
        `${urlPrefix}getDatewiseIREData?startDate=${startDate}&endDate=${endDate}`,
      );

      if (response.data.status === "ok" && Array.isArray(response.data.data)) {
        setRawdata(response.data.data);
        setCurrentPage(1);
      } else {
        setRawdata([]);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    fetchData();
  }, [startDate, endDate]);

  ///////////////////////////////////

  const fetchMonthWiseData = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(
        `${urlPrefix}getDatewiseIREDataMonthWiseFinancialYear`,
      );
      if (response.data.status === "ok" && Array.isArray(response.data.data)) {
        setSummaryData(response.data.data);
      } else {
        setSummaryData([]);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };
  useEffect(() => {
    fetchMonthWiseData();
  }, []);

  /////////////////////////////////////
  const fetchMonthlyAndYearlyData = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(
        `${urlPrefix}getIREDataAllFormate?date=?date=${date}`,
      );

      if (response.data.status === "ok" && Array.isArray(response.data.data)) {
        setMonthWiseData(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };
  useEffect(() => {
    fetchMonthlyAndYearlyData();
  }, [date]);
  /////////////////////////////////////

  const totalEntries = rawdata.length;
  const totalPages = Math.ceil(totalEntries / entriesPerPage);

  return (
    <div>
      <div className="newUiBody">
        <h5 className="text-center bg-dark text-white p-1 m-1">
          Filter by Date
        </h5>
        <div className="d-flex justify-content-center">
          <div className="m-2">
            <label>Start Date</label>
            <input
              type="date"
              max={getCurrentDate()}
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="form-control"
            />
          </div>
          <div className="m-2">
            <label>End Date</label>
            <input
              type="date"
              max={getCurrentDate()}
              min={startDate}
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="form-control"
            />
          </div>
        </div>
        {loading && <p className="text-center">Loading data...</p>}
        {error && (
          <p className="text-center text-danger">Error loading data.</p>
        )}

        <div className="d-flex justify-content-center">
          {keys.map((key, index) => {
            return (
              <DateWiseJBB
                key={index}
                currentPage={currentPage}
                entriesPerPage={entriesPerPage}
                data={rawdata}
                keyName={key}
              />
            );
          })}
        </div>
        {/* /////////////////// */}
        <div className="d-flex justify-content-center my-2">
          <button
            className="btn btn-sm btn-primary me-2"
            onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span className="mx-2">
            Page {currentPage} of {totalPages === 0 ? 1 : totalPages}
          </span>
          <button
            className="btn btn-sm btn-primary"
            onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
            disabled={currentPage >= totalPages}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default TableMaster;
